import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CalculatorHeadingProps } from './types';

export const CalculatorHeading: FC<CalculatorHeadingProps> = ({ labelKey }) => (
  <h4 className={'font-satoshi-black text-dark xs:text-base xs:mb-0.5 m-0 font-black md:mb-2 md:text-xl'}>
    <FormattedMessage id={labelKey} />
  </h4>
);
